<template>
  <div class="_modals">
    <b-modal
      id="setting-form-address"
      ref="modalFormAddress"
      centered
      hide-footer
      :title="title"
    >
      <div class="accountsform">
        <form>
          <div class="row pb-3">
            <div class="col-md-5 pr-1">
              <div class="input__model1group">
                <p style="font-weight: bold;" class="inbut-label">Label</p>
                <b-form-input
                  name="Fullname"
                  v-model="form.label"
                  v-validate="'required'"
                  placeholder="Label"
                  :disabled="form.label.toLowerCase() === 'main office'"
                />
                <div class="fontstyle__errormsg">
                  {{ errors.first("Label") }}
                </div>
              </div>
            </div>
            <div class="col-md-7 pr-1">
              <div class="input__model1group">
                <p style="font-weight: bold;" class="input-label">Company Name</p>
                <b-form-input
                  name="companyName"
                  v-model="form.companyName"
                  v-validate="'required'"
                  placeholder="Enter Company Name "
                />
                <div class="fontstyle__errormsg">
                  {{ errors.first("Company Name") }}
                </div>
              </div>
            </div>
          </div>
          <div class="row pb-2">
            <div class="col-md-6 pr-1">
              <div class="input__model1group">
                <p style="font-weight: bold;" class="input-label">Phone Number</p>
                <div class="d-flex">
                  <div
                    class="options__multipleselect"
                    style="margin-right: 10px; max-width: 45%"
                  >
                    <multiselect
                      v-model="selectedPhoneCode"
                      :options="optionDialCode || []"
                      @input="inputSelectPhoneCode"
                      :custom-label="customPhoneLabel"
                      placeholder="Select"
                      :allow-empty="false"
                      :show-labels="false"
                    >
                      <span slot="noResult">Oops! No elements found.</span>
                    </multiselect>
                    <img
                      class="options__multipleselect--imgabsolute"
                      src="@/assets/image/icon/icon-arrow-blue.png"
                    />
                  </div>
                  <b-form-input
                    v-model="form.phoneNumber"
                    name="phoneNumber"
                    v-validate="'required'"
                    placeholder="E.g: 8771234567 "
                    type="number"
                  />
                      <div class="fontstyle__errormsg">
                  {{ errors.first("Phone Number") }}
                </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 pr-1">
              <div class="input__model1group">
                <p style="font-weight: bold;" class="input-label">NPWP Number</p>
                <b-form-input
                  v-model="form.npwp"
                  maxlength="20"
                  name="NPWP"
                  v-validate="'required'"
                  placeholder="Type NPWP Number"
                  @input="formatNpwp(form.npwp)"
                />
                  <!-- <div v-if="form.npwp.length > 1 && form.npwp.length < 20"
                      class="fontstyle__errormsg" > NPWP number is 15 digit
                  </div>
                <div class="fontstyle__errormsg">
                  {{ errors.first("NPWP") }}
                </div> -->
              </div>
            </div>
          </div>
          <div class="row pb-2">
            <div class="col-md-6 pr-1">  <div class="input__model1group">
                <p style="font-weight: bold;" class="input-label">Country</p>
                <div class="options__multipleselect">
                 <multiselect
                    v-model="selectedCountry"
                    :options="optionCountry || []"
                    label="name"
                    placeholder="Select Country"
                    @input="inputSelectCountry"
                    name="Salesperson"
                    :allow-empty="false"
                    :show-labels="false"
                  >
                    <span slot="noResult"
                      >Oops! No elements found.</span
                    >
                  </multiselect>
                  <img
                    class="options__multipleselect--imgabsolute"
                    src="@/assets/image/icon/icon-arrow-blue.png"
                  />
                </div>
                <div class="fontstyle__errormsg">
                  {{ errors.first("Country") }}
                </div>
              </div>
              
            </div>
            <!-- city ini nnti di hapus -->
            <div class="col-md-6 pr-1">
            <div class="input__model1group">
                <p style="font-weight: bold;" class="input-label">City</p>
                <div class="options__multipleselect">
                  <multiselect
                    v-model="selectedCity"
                    :options="optionCity"
                    label="name"
                    @input="inputSelectCity"
                    placeholder="Select City"
                    name="Salesperson"
                    :allow-empty="false"
                    :show-labels="false"
                  >
                    <span slot="noResult">Oops! No elements found.</span>
                  </multiselect>
                  <img
                    class="options__multipleselect--imgabsolute"
                    src="@/assets/image/icon/icon-arrow-blue.png"
                  />
                </div>
                <div class="fontstyle__errormsg">
                  {{ errors.first("City") }}
                </div>
              </div>
            <!-- <div class="col-md-6 pr-1">
              <div class="input__model1group">
                <p class="input-label">Province</p>
                <div class="options__multipleselect">
                  <multiselect
                    v-model="selectedProvince"
                    :options="optionProvince"
                    label="name"
                    @input="inputSelectProvince"
                    placeholder="Select Province"
                    name="Province"
                    :allow-empty="false"
                    :show-labels="false"
                  >
                    <span slot="noResult">Oops! No elements found.</span>
                  </multiselect>
                  <img
                    class="options__multipleselect--imgabsolute"
                    src="@/assets/image/icon/icon-arrow-blue.png"
                  />
                </div>
                <div class="fontstyle__errormsg">
                  {{ errors.first("Province") }}
                </div>
                <div class="fontstyle__errormsg">
                  -
                </div>
              </div>
            </div> -->
          </div>
          <div class="row pb-2">
            <!-- <div class="col-md-6 pr-1">
              <div class="input__model1group">
                <p class="input-label">City</p>
                <div class="options__multipleselect">
                  <multiselect
                    v-model="selectedCity"
                    :options="optionCity"
                    label="name"
                    @input="inputSelectCity"
                    placeholder="Select City"
                    name="Salesperson"
                    :allow-empty="false"
                    :show-labels="false"
                  >
                    <span slot="noResult">Oops! No elements found.</span>
                  </multiselect>
                  <img
                    class="options__multipleselect--imgabsolute"
                    src="@/assets/image/icon/icon-arrow-blue.png"
                  />
                </div>
                <div class="fontstyle__errormsg">
                  {{ errors.first("City") }}
                </div>
                <div class="fontstyle__errormsg">
                  -
                </div>
              </div> -->
              
            </div>
            <!-- <div class="col-md-6 pr-1">
              <div class="input__model1group">
                <p class="input-label">District</p>
                <div class="options__multipleselect">
                  <multiselect
                    v-model="selectedDistrict"
                    :options="optionDistrict"
                    label="name"
                    @input="inputSelectDistrict"
                    placeholder="Select District"
                    name="Salesperson"
                    :allow-empty="false"
                    :show-labels="false"
                  >
                    <span slot="noResult">Oops! No elements found.</span>
                  </multiselect>
                  <img
                    class="options__multipleselect--imgabsolute"
                    src="@/assets/image/icon/icon-arrow-blue.png"
                  />
                </div>
                <div class="fontstyle__errormsg">
                  {{ errors.first("District") }}
                </div>
                <div class="fontstyle__errormsg">
                  -
                </div>
              </div>
            </div> -->
          </div>
          <div class="row pb-2">
            <!-- <div class="col-md-6 pr-1">
              <div class="input__model1group">
                <p class="input-label">Sub-District</p>
                <div class="options__multipleselect">
                  <multiselect
                    v-model="selectedSubdistrict"
                    :options="optionSubdistrict"
                    @input="inputSelectSubdistrict"
                    label="name"
                    placeholder="Select Sub-District"
                    name="Salesperson"

                    :allow-empty="false"
                    :show-labels="false"
                  >
                    <span slot="noResult">Oops! No elements found.</span>
                  </multiselect>
                  <img
                    class="options__multipleselect--imgabsolute"
                    src="@/assets/image/icon/icon-arrow-blue.png"
                  />
                </div>
                <div class="fontstyle__errormsg">
                  {{ errors.first("Sub-District") }}
                </div>
                <div class="fontstyle__errormsg">
                  -
                </div>
              </div>
            </div> -->
            <div class="col-md-6 pr-1">
              <div class="input__model1group">
                <p style="font-weight: bold;" class="input-label">Post Code</p>
                <b-form-input
                  v-model="form.postCode"
                  name=">postCode"
                  v-validate="'required'"
                  placeholder="Enter Post Code"
                  type="number"
                />
                <div class="fontstyle__errormsg">
                  {{ errors.first(">Post Code") }}
                </div>
              </div>
            </div>
          </div>
          <div class="row pb-2">
            <div class="col-md-12 pr-1">
              <div class="input__model1group marginright3">
                <p style="font-weight: bold;" class="input-label">Address</p>
                <b-form-textarea
                  v-model="form.address"
                  name="Company Address"
                  type="text"
                  v-validate="'required'"
                  placeholder="Type Company Address"
                  rows="5"
                  max-rows="6"
                  style="max-height: 105px"
                />
                <div
                  class="fontstyle__errormsg"
                  v-if="errors.first('Company Address')"
                >
                  {{ errors.first("Company Address") }}
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center w-100 pl-2 pt-4">
            <button
              class="button__formwhite mr-4 px-2"
              style="border"
              @click.prevent="dialogCancelEdit"
            >
              Cancel
            </button>
            <button :disabled="!this.form.label || !this.form.companyName || !this.form.phoneNumber || !this.form.phoneCode || !this.form.countryId || !this.form.cityId || !this.form.postCode || !this.form.address" 
            class="button__bluecorporite ml-4" 
            @click.prevent="dialogSaveEdit">
              Save
            </button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'FormAddress',
  data () {
    return {
      title: 'Add New Address',
      codeValue: '+62',
      countryValue: '',
      industryValue: '',
      comp_alert_msg: '',
      isUpdated: false,
      form: {
        label: '',
        companyName: '',
        phoneNumber: '',
        phoneCode: '',
        npwp: '',
        countryId: 0,
        provinceId: 0,
        cityId: 0,
        districtId: 0,
        subdistrictId: 0,
        postCode: '',
        address: ''
      },
      selectedPhoneCode: {},
      selectedCountry: '',
      selectedProvince: '',
      selectedCity: '',
      selectedDistrict: '',
      selectedSubdistrict: '',
      optionDialCode: [],
      optionCountry: [],
      optionProvince: [],
      optionCity: [],
      optionDistrict: [],
      optionSubdistrict: [],
      addressId: '',
      currentPage: 1,
      perPage: 4
    }
  },
  // mounted(){
  //   this.getDialCode()
  //   this.fetchCountries()
  // },
  created () {
    this.$eventHub.$on('dialog-form-address', this.dialogFormAddress)
  },
  beforeDestroy () {
    this.$eventHub.$off('dialog-form-address')
  },
  methods: {
    formatNpwp (value) {
      value = value.replace(/[A-Za-z\W\s_]+/g, '')
      let split = 6
      const dots = []

      for (let i = 0, len = value.length; i < len; i += split) {
        split = i >= 2 && i <= 6 ? 3 : i >= 8 && i <= 12 ? 4 : 2
        dots.push(value.substr(i, split))
      }

      const temp = dots.join('.')
      let npwp = temp.length > 12 ? `${temp.substr(0, 12)}-${temp.substr(12, 7)}` : temp

      this.form.npwp = npwp
    },
    removeZeroFirstChar (phoneString) {
      let str = phoneString ? phoneString.toString() : null
      if (phoneString) {
        if (str.charAt(0) === '+') {
          str = str.substring(3) // remove first character
        }

        if (str.charAt(0) === '0') {
          str = str.substring(1) // remove first character
        } else if (str.charAt(0) === '6' && str.charAt(1) === '2') {
          str = str.substring(2)
        }
      }
      return `${str}`
    },
    inputSelectPhoneCode () {
      this.form.phoneCode = this.selectedPhoneCode.phonecode
    },
    inputSelectCountry () {
      this.form.countryId = this.selectedCountry.id
    },
    inputSelectProvince () {
      this.form.provinceId = this.selectedProvince.id
    },
    inputSelectCity () {
      this.form.cityId = this.selectedCity.id
    },
    inputSelectDistrict () {
      this.form.districtId = this.selectedDistrict.id
    },
    inputSelectSubdistrict () {
      this.form.subdistrictId = this.selectedSubdistrict.id
    },
    dialogFormAddress (data) {
      if (data.title === 'Edit Address') {
        this.title = 'Edit Address'
        this.addressId = data.data.id
        this.selectedPhoneCode.phonecode = data.data.phoneCode    
        this.form.phoneCode = data.data.phoneCode    
        this.form.label = data.data.label
        this.form.companyName = data.data.companyName
        this.form.npwp = data.data.npwp
        this.form.postCode = data.data.postCode
        this.form.address = data.data.address
        this.form.countryId = data.data.country_id
        this.form.provinceId = data.data.province_id
        this.form.cityId = data.data.city_id
        this.form.districtId = data.data.district_id
        this.form.subdistrictId = data.data.subdistrict_id  
        this.form.phoneNumber = this.removeZeroFirstChar(data.data.phoneNumber)   
        this.selectedCountry = {id: data.data.country_id, name: data.data.countryName}
        this.selectedProvince = {id: data.data.province_id, name: data.data.provinceName}
        this.selectedCity = {id: data.data.city_id, name: data.data.cityName}
        this.selectedDistrict = {id: data.data.district_id, name: data.data.districtName}
        this.selectedSubdistrict = {id: data.data.subdistrict_id, name: data.data.subdistrictName}
        this.currentPage = data.currentPage
      } else if (data.title === 'Add Address') {
        this.title = 'Add New Address'
        this.form = {
          label: '',
          companyName: '',
          phoneNumber: '',
          phoneCode: '',
          npwp: '',
          countryId: 0,
          provinceId: 0,
          cityId: 0,
          districtId: 0,
          subdistrictId: 0,
          postCode: '',
          address: ''
        }
        this.selectedPhoneCode = ''
        this.selectedCountry = ''
        this.selectedProvince = ''
        this.selectedCity = ''
        this.selectedDistrict = ''
        this.selectedSubdistrict = ''
        this.currentPage = data.currentPage
        this.optionProvince = []
        this.optionCity = []
        this.optionDistrict = []
        this.optionSubdistrict = []
      }      
      this.$refs.modalFormAddress.show()
    },
    dialogSaveEdit () {
      this.$refs.modalFormAddress.hide()
      if (this.title === 'Edit Address') {
        this.$eventHub.$emit('dialog-modal-option', {
          title: this.title,
          title1: 'You can use this new address once its verified by Andalin',
          title2: 'Are you sure wants to save this change in address ?',
          data: this.form,
          id: this.addressId,
          modeOption: 'editSettingAddress',
          currentPage: this.currentPage 
        })
      } else if (this.title === 'Add New Address') {
        this.postNewAddress()
      }
    },
    dialogCancelEdit () {
      this.$refs.modalFormAddress.hide()
    },
    async postNewAddress () {
      await this.$store.dispatch('address/ADD_MORE_ADDRESS', this.form)
      this.$eventHub.$emit('dialog-modal-confirm', {
        option: 'yes',
        message: 'Success add address.'
      })
      this.$store.dispatch('address/FETCH_ALL_ADDRESS', {page: this.currentPage, perPage: this.perPage})
    },
    async getDialCode () {
      await this.$store.dispatch('auth/FETCH_DIAL_COUNTRY_CODE')
    },
    async fetchCountries () {
      await this.$store.dispatch('settingCompany/FETCH_COUNTRIES')
    },
    async fetchCityByCountryId (countryId) {
      await this.$store.dispatch('settingCompany/FETCH_CITY_BY_COUNTRIES', countryId)
    },
    async modifydata () {
      this.datacheck()
      if (this.form.userEmail) {
        const payload = {
          userEmail: this.form.userEmail
        }
        await this.$store.dispatch('auth/EMAIL_CHECK', payload)
      }
      await this.emitToParent()
    },
    // eslint-disable-next-line standard/object-curly-even-spacing
    customPhoneLabel ({ phonecode, code}) {
      return `+${phonecode} - ${code}`
    },
    // eslint-disable-next-line standard/object-curly-even-spacing
    customPhoneSelectedLabel ({ phonecode}) {
      return `+${phonecode}`
    }
  },
  computed: {
    ...mapGetters({
      auth: 'auth/items',
      error: 'auth/error',
      isLoading: 'auth/isLoading',

      dialcode: 'auth/dialcode',
      isLoadingDialcode: 'auth/isLoadingDialcode',

      countryList: 'settingCompany/countries',
      isErrorCountries: 'settingCompany/error',
      countriesIsLoading: 'settingCompany/countriesIsLoading',

      cityBycountries: 'settingCompany/cityBycountries',
      isErrcityBycountries: 'settingCompany/isErrcityBycountries',
      isLoadingcityBycountries: 'settingCompany/isLoadingcityBycountries',

      getProvincesByCountryId: 'city/getProvincesByCountryId',
      isLoadingProvincesByCountryId: 'city/isLoadingProvincesByCountryId',
      errorProvincesByCountryId: 'city/errorProvincesByCountryId',

      cityByProvinceId: 'city/getCityByProvinceId',
      isLoadingCityByProvinceId: 'city/isLoadingCityByProvinceId',
      errorCityByProvinceId: 'city/errorCityByProvinceId',

      districtByCityId: 'city/getDistrictByCityId',
      isLoadingDistrictByCityId: 'city/isLoadingDistrictByCityId',
      errorDistrictByCityId: 'city/errorDistrictByCityId',

      subdistrictByDistrictId: 'city/getSubdistrictByDistrictId',
      isLoadingSubdistrictByDistrictId: 'city/isLoadingSubdistrictByDistrictId',
      errorSubdistrictByDistrictId: 'city/errorSubdistrictByDistrictId'
    })
  },
  watch: {
    async selectedCountry (data) {
      if (data) {
        this.fetchCityByCountryId(data.id)
      } else {
        this.optionCity = []
      }
    },
    async selectedProvince (data) {
      if (data) {
        await this.$store.dispatch('settingCompany/FETCH_CITY_BY_COUNTRIES', data.id)
      }
    },
    async selectedCity (data) {
      if (data) {
        await this.$store.dispatch('city/FETCH_DISTRICT_BY_CITY', data.id)
      }
    },
    async selectedDistrict (data) {
      if (data) {
        await this.$store.dispatch('city/FETCH_SUBDISTRICT_BY_DISTRICT', data.id)
      }
    },
    dialcode (data) {
      if (data) {
        this.optionDialCode = data.data
      }
    },
    countryList (data) {
      if (data) {
        this.optionCountry = data.data
      }
    },
    cityBycountries (data) {
      if (data) {
        this.optionCity = data.data
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/modals/AddressForm.vue